import { Link } from '@hc-frontend/core-ui';

export function HealthcareInsuranceDisclaimerTop() {
  return (
    <>
      By submitting your information and clicking below, you represent that you
      are at least 18 years old and provide your express written consent to be
      contacted by HealthCare, Inc. and/or its partner companies and{' '}
      <Link
        id="survey-pii-partner-companies"
        href="https://www.healthcare.com/partner-companies"
        rel="noreferrer noopener"
        target="_blank"
      >
        <b>
          <u>any of their commercial partners</u>
        </b>
      </Link>{' '}
      at the number and email you provided (including any wireless number)
      regarding various insurance products through the use of automated
      telephone dialing systems, pre-recorded messages, and/or text messages.
      Message and data rates may apply. Your consent is not a condition of
      purchase. This program is subject to our{' '}
      <Link
        id="survey-pii-privacy-policy"
        href="https://www.healthcare.com/privacy-policy"
        rel="noreferrer noopener"
        target="_blank"
      >
        <b>
          <u>Privacy Policy</u>
        </b>
      </Link>{' '}
      and{' '}
      <Link
        id="survey-pii-terms"
        href="https://www.healthcare.com/terms"
        rel="noreferrer noopener"
        target="_blank"
      >
        <b>
          <u>Terms of Use.</u>
        </b>
      </Link>
    </>
  );
}

export function HealthcareInsuranceDisclaimerBottom() {
  return (
    <>
      Any plan prices and details shown are our initial estimates. To buy a
      plan, you must complete an application process with one of our partners
      that is licensed to sell insurance products and that will provide you more
      definitive information on plan prices, benefits, availability, and other
      details. You may also call to inquire and/or purchase. You may be directed
      to a licensed sales agent who can answer your questions and provide
      information about individual health insurance plans. Agents are not
      connected with or endorsed by the U.S. government.
    </>
  );
}
